import Image from "next/image";
import React from "react";

export interface EventExperienceCardData {
    eyebrow: string;
    title: string;
    description: string;
    image: string;
    icon: string;
}

interface EventExperienceCardProps {
    data: EventExperienceCardData;
    lastItem: boolean;
}

const renderDescription = (description: string) =>
    description.split(/(\*\*.+?\*\*)/g).map((part, index) => {
        const boldMatch = part.match(/^\*\*(.+)\*\*$/);

        if (!boldMatch) {
            return <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>;
        }

        return <strong key={`${boldMatch[1]}-${index}`}>{boldMatch[1]}</strong>;
    });

const EventExperienceCard: React.FC<EventExperienceCardProps> = ({ data, lastItem }) => {
    const { eyebrow, title, description, image, icon } = data;

    return (
        <article className={`mx-auto max-w-5xl flex flex-col md:flex-row gap-10 md:gap-20 py-10 md:py-20  ${!lastItem ? "border-b border-solid border-gray-200" : ""}`}>
            <div className="md:w-1/2">
                <Image src={image} alt={title} width={580} height={580} />
            </div>
            <div className="md:w-1/2 flex flex-col justify-between">
                <div>
                    <h3 style={{ fontFamily: "Degular Display", fontWeight: "bold" }} className="text-6xl mb-5">
                        {title}
                    </h3>
                    <p className="text-xl font-medium font-inter" style={{ color: "rgba(26, 32, 44, 1)" }}>
                        {renderDescription(description)}
                    </p>
                </div>

                <div className="flex items-center justify-end gap-4 py-2 px-4 mt-8 md:mt-0" style={{ backgroundColor: "rgba(247, 250, 252, 1)", borderRadius: "16px" }}>
                    <p className="text-sm font-medium font-inter" style={{ color: "rgba(113, 128, 150, 1)", textTransform: "uppercase" }}>
                        {eyebrow}
                    </p>
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[16px]">
                        <Image src={icon} alt={`${eyebrow} icon`} width={56} height={56} />
                    </div>
                </div>
            </div>
        </article>
    );
};

export default EventExperienceCard;
